var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-md-center"},[_c('v-avatar',{attrs:{"color":"grey lighten-4","size":"120"}},[_c('img',{attrs:{"src":_vm.publicPath('/img/avatar.jpg'),"alt":"James Chase Martin"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }